export default __webpack_public_path__ + "static/media/38_photo.a49d4b5f.jpg";